import { render, staticRenderFns } from "./Challenge4.vue?vue&type=template&id=5afad96c&scoped=true&lang=pug&"
import script from "./Challenge4.vue?vue&type=script&lang=ts&"
export * from "./Challenge4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afad96c",
  null
  
)

export default component.exports